import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useForm, useWatch } from 'react-hook-form';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import { useDispatch, useSelector } from 'react-redux';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';
import { format } from 'date-fns';
import { setPostUsers } from '../../../../store/mailing/thunk/setPostUsers';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0,0,0,0.2)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999
    },
    form: {
        background: '#1c2542',
        borderRadius: 8,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        rowGap: '12px',
        minWidth: 500,
  
    },
    field: {
        padding: 10,
        paddingLeft: 10,
        border: '1px solid #141b33',
        outline: 'none',
        margin: 10,
        color: '#000',
        width: 'calc(100% - 40px)',
        '&::placeholder': {
            color: '#000'
        }
    },
    btn: {
        padding: '8px 14px',
        borderRadius: 4,
        background: 'gold',
        color: '#000',
        cursor: 'pointer',
        border: 'none',
        fontSize: 18
    },
    btn_disabled: {
        padding: '8px 13px',
        borderRadius: 4,
        background: 'none',
        color: '#ACACAC',
        border: '1px solid gold',
        cursor: 'pointer',
        fontSize: 18
    }
}))

const ModalAddMailing = ({
    handleChangeModeAddMailing,
    login: props_login
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            gift_type: '',
        }
    })

    React.useEffect(() => {
        dispatch(setGetMailing({
            page: 1,
            pageSize: 999,
            is_start: false
        }))
    }, []);

    const onSubmit = (store) => {
        dispatch(setPostUsers(store, handleCancel));
    }

    const [login, gift_type, gift_value, mailing_id] = useWatch({
        control,
        name: ['login', 'gift_type', 'gift_value', 'mailing_id', 'login']
    });

    const handleCancel = () => {
        handleChangeModeAddMailing();
        reset({})
    }

    React.useEffect(() => {
        setValue('login', props_login)
    }, [props_login])

    const LIST_GIFTS = [{
        label: 'Фриспины',
        value: 'freespin'
    }, {
        label: 'Бонусные деньги',
        value: 'bonus_money'
    }];

    const isValid = !login || !gift_type || !gift_value || !mailing_id;

    const mailing = useSelector((state) => state.mailing.list.data);

    return (
        <div className={classes.root}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div style={{display: 'flex', flexDirection: 'column', rowGap: 12}}>
                    <FieldInput
                        name="login"
                        placeholder="Логин пользователя"
                        disabled
                        register={register}
                    />
                    <FieldSelect
                        register={register}
                        label="Рассылка"
                        name="mailing_id"
                        list={mailing.map((item) => ({
                            value: item.id,
                            label: `${format(new Date(Number(item.mailing_date_at)), 'dd.MM.yyyy')}/${item.label}`
                        }))}
                        defaultOption="Выбрать рассылку"
                    />
                    <FieldSelect
                        register={register}
                        label="Тип подарка"
                        name="gift_type"
                        list={LIST_GIFTS}
                        defaultOption="Выбрать подарок"
                    />
                    <FieldInput
                        name="gift_value"
                        placeholder="Количество/сумма подарка"
                        register={register}
                    />
                </div>
                <div style={{ display: 'flex', columnGap: 12, justifyContent: 'flex-end' }}>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className={classes.btn_disabled}
                    >
                        Отменить
                    </button>
                    <button
                        type="submit"
                        disabled={isValid}
                        className={!isValid ? classes.btn : classes.btn_disabled}
                    >
                        Создать
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ModalAddMailing;